import { Mutation, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function mockedSetVisitorWithRoleData(setVisitorById: Visitor): Pick<Mutation, 'setVisitorById'> {
  return {
    setVisitorById
  };
}

export const mockedSetVisitorWithRoleDataForMutation = mockedSetVisitorWithRoleData(
  generateMockVisitor({
    id: 'mockedVisitorIdExternalUserNew',
    name: 'mockedVisitorNameExternalUserNew',
    email: 'mockedVisitorEmailExternalUserNew',
    isAdmin: false,
    visitorGroupMembership: []
  })
);
